<template>
<div v-if="isVisible">
<div v-if="isLoading" class="loading">Loading&#8230;</div>

<div id="myModalProgram" class="modal">
  <div class="modal-background" @click="close_modal()"></div>
  <div class="modal-content" style="width:60%; height:85%;">
    <div  class="box">

<div class="columns is-multiline box has-background-grey">

<div class="column is-4"></div>

<div class="column is-3">
<div class="columns is-gapless">
    <div class="column is-10">
        <input  v-model="search" placeholder="Filter" class="input has-text-left is-fullwidth"> 
    </div>
    <div @click="search=''" class="column is-2 isLink has-text-centered" style="">
        <span class="icon is-small has-text-light mt-3"><i class="fas fa-minus-circle"></i></span>
    </div>
</div></div>

<div class="column is-1">
        <button @click="close_modal()" class="button is-fullwidth has-background-danger has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-trash"></i></span>     
        </button> 
</div>
<div class="column is-4">
    <button @click="modal_save()" class="button is-fullwidth has-background-success has-text-white">
        <span class="icon is-small has-text-left"><i class="fas fa-save"></i></span>     
    </button> 
</div>


<div class="column is-3 isLink" style="" v-for ="(data, index) in modal_data" :key="index">
<div class="columns is-multiline is-gapless">
    <div class="column is-10 colBorderThin has-background-light has-text-weight-bold">&nbsp;&nbsp;{{data.code}}</div>
    <div class="column is-2 has-text-centered has-background-white"><input v-model="data.isSelected" type="checkbox"></div>
    <div class="column is-12 doFontSmallest colBorderThin has-background-white has-text-weight-bold">&nbsp;&nbsp;{{data.descF}}</div>
    <div class="column is-12 doFontSmallest colBorderThin has-background-white has-text-weight-bold">&nbsp;&nbsp;{{data.descE}}</div>
</div></div>
</div>


        </div>
    </div>
</div>
<!-- END MODAL SHED !  -->


<div class="columns is-multiline is-gapless has-background-light">
<div class="column  is-3">
<div class="columns is-gapless is-multiline">
    <div class="column is-2 mt-2 has-text-centered">
      <span class="doFontSmallest has-background-warning"> &nbsp; CODE &nbsp; </span>
    </div>

    <div class="column is-4 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="isChanged = true" v-model="data.prog_CODE" placeholder="Code" class="input is-fullwidth"> 
    </div>

    <div class="column is-2 mt-2 has-text-centered">
      <span class="doFontSmallest has-background-warning"> &nbsp; PLUS &nbsp; </span>
    </div>

    <div class="column is-4 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="isChanged = true" v-model="data.prog_CODEPLUS" placeholder="Code +" class="input is-fullwidth"> 
    </div>

    <div class="column is-2 mt-2 has-text-centered">
      <span class="doFontSmallest has-background-warning"> &nbsp; ANNEE &nbsp; </span>
    </div>
    <div class="column is-4 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="isChanged = true" v-model="data.prog_YEAR" placeholder="Year" class="input is-fullwidth has-text-centered"> 
    </div>
    <div class="column is-2 mt-2 has-text-centered">
      <span class="doFontSmallest has-background-warning"> &nbsp; AEC &nbsp; </span>
    </div>
    <div class="column is-4 has-text-centered has-text-weight-bold is-size-6 mt-3" style="">   
        <!-- <input @keyup="isChanged = true" v-model="data.prog_blnAEC" placeholder="Year" class="input is-fullwidth has-text-centered">  -->
                <input v-model="data.prog_blnAEC" type="checkbox" id="bAEC" class="checkbox is-fullwidth" />  
                <label for="bAEC" class="switch"></label>
    </div>


</div></div>
<!-- END CODE COLUMN  -->

<div class="column  is-7">
<div class="columns is-gapless is-multiline">

    <div class="column is-1 mt-2 has-text-centered">
      <span class="doFontSmallest has-background-warning"> &nbsp; FRA &nbsp; </span>
    </div>

    <div class="column is-11 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="isChanged = true" v-model="data.prog_TITRE_F" placeholder="French Desc" class="input is-fullwidth"> 
    </div>

<!-- <div class="column is-2" style="margin-bottom:-.2em;">
 <a @click="printit()" class="button is-fullwidth has-background-white"><span class="icon"><i class="fas fa-print"></i></span>&nbsp;&nbsp;Print</a>
</div> -->

    <div class="column is-1 mt-2 has-text-centered">
      <span class="doFontSmallest has-background-warning"> &nbsp; ANG &nbsp; </span>
    </div>
    <div class="column is-11 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> 
        <input @keyup="isChanged = true" v-model="data.prog_TITRE_E" placeholder="English Desc" class="input is-fullwidth"> 
    </div>





<!-- <div class="column is-2" style="margin-bottom:-.2em;">
<div class="columns is-centered" v-if="data.prog_ID == 0">
    <div class="column is-10 field is-fullwidth">
        <input v-model="data.prog_blnAEC" id="switchActive" type="checkbox" name="switchActive" class="switch is-small is-fullwidth is-success">
        <label for="switchActive">COMPS</label>
    </div>
</div>
<div class="columns" v-else>
    <div v-if="data.prog_blnAEC" class="column is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> <a @click="program_get_competences(index)"  class="button has-text-link is-fullwidth"><span class="icon is-small"> <i class="fas fa-ellipsis-h"></i> </span> <span>COMPS</span></a>  </div>
    <div v-else class="column is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> <a @click="program_get_courses(index)"  class="button has-text-primary is-fullwidth"><span class="icon is-small"> <i class="fas fa-th-list"></i> </span> <span>COURS</span></a>   </div>
</div>
</div> -->








 </div></div>
<!-- END COL 2 -- DESC -->



<div class="column is-2 " style="">
<div class="columns is-gapless is-multiline">

  <div class="column has-text-centered is-12 has-text-weight-bold has-text-danger" style="margin-bottom:-.2em;"> 
    <button @click="program_delete_confirm()" class="button is-fullwidth has-background-light has-text-danger"><span class="icon mr-2 is-small has-text-danger"> <i class="fas fa-trash-alt"></i> </span></button>
  </div> 

<div v-if="data.prog_ID != 0" class="column is-6" style="margin-bottom:-.2em;">
 <a @click="program_fee_show()" class="button is-fullwidth has-background-light has-text-info"><span class="icon mr-2"><i class="fas fa-donate"></i></span></a>
</div>

<div v-if="data.prog_ID != 0" class="column is-6" style="margin-bottom:-.2em;">
 <a @click="program_get_competences_click()" class="button is-fullwidth has-background-light has-text-info"><span class="icon mr-2"><i class="fas fa-list-alt"></i></span></a>
</div>




</div></div>
<!-- END COL 3 -- DELETE -->

 <!-- PROGRAM SAVE  -->
    <div v-if="isChanged==true" class="column has-text-centered is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="program_save()" class="button is-success is-fullwidth"><span class="icon is-small has-text-white"> <i class="fas fa-save"></i> </span>&nbsp;&nbsp;&nbsp;SAVE</button>
    </div>





</div>


<div  v-if="!show_details && !show_fees" class="columns is-gapless">
    <div class=" column is-12 mb-6 doFontSmallestest has-background-grey">&nbsp;</div>
</div>




<div v-if="show_details" class="columns is-multiline is-gapless box">

<div class="column is-12" style="margin-top:0em;margin-bottom:4em;">
<div class="columns is-multiline">


<div class="column is-4" v-for="(data,index1) in data_prog_competences" :key="index1">

<div class="columns is-gapless colBorderThin has-background-light " style="margin-bottom:0em;">
<div class="column colNotes is-10 mt-2 has-text-weight-bold">
    &nbsp;{{data.comp_CODE}} : <span class="doFontSmallest">{{data.comp_TITRE_F}}</span>
</div>    
<div class="column is-2">
        <button @click="show_modal('COUR', index1)" class="button is-fullwidth is-small has-background-grey has-text-white">
            <span class="icon"><i class="fas fa-edit"></i></span>     
        </button> 
</div>

</div>
    <div class="columns is-gapless is-multiline colBorderThin" v-for="(cour,index2) in program_get_courses(data.comp_ID)" :key="index2" style="margin-bottom:0em;">
        <div class="column is-8">
                &nbsp;&nbsp;{{cour.cour_TITRE_F}}
        </div>      
        <div class="column is-4 has-text-right is-size-7 has-text-weight-bold has-text-info">
                {{cour.cour_CODE}}&nbsp;
        </div>
    </div>
</div><!-- END COMP LOOP  -->

<!-- NEW !!!!  -->
<div class="column is-4">
<div class="columns is-centered is-multiline is-gapless box has-background-grey">
    <div v-if="data.prog_blnAEC==true" class="column is-8 has-text-centered has-text-light has-text-weight-bold">AJOUTER COMP. </div>
    <div v-else class="column is-8 has-text-centered has-text-light has-text-weight-bold">AJOUTER COUR </div>
    <div class="column is-8">
        <button v-if="data.prog_blnAEC==true" @click="show_modal('COMP',-1)" class="button is-small is-fullwidth has-background-success has-text-white">
            <span class="icon"><i class="fas fa-plus"></i></span>     
        </button> 
        <button v-else @click="show_modal('COUR',-1)" class="button is-small is-fullwidth has-background-success has-text-white">
            <span class="icon"><i class="fas fa-plus"></i></span>     
        </button>
    </div>
</div></div>




</div></div> <!-- END COUR/COMP LIST  -->
<div class=" column is-12 doFontSmallestest has-background-grey">&nbsp;</div>
</div>



<div v-if="show_fees" class="columns is-multiline is-centered is-gapless" style="margin-top:0em;margin-bottom:4em;">
<!-- <div class="column is-7"></div> -->
<div class="column is-8">
    <CompProgFees :progID="data.prog_ID" :key="randomKey()"></CompProgFees>
</div> 
<div class=" column is-12 mb-4 doFontSmallestest has-background-grey">&nbsp;</div>
</div>
<!-- END FEEs DETAILS  -->



 
<!-- END MAIN COLUMN  -->
</div>
</template>


<script>
import axios from 'axios'

import CompProgFees from "@/views/Admin/Comp_Admin_Ped_Program_Fees"

export default {
    props: [ 'data' , 'data_comp' , 'data_cour'  ],
    components: {CompProgFees},

    data() {
        return {
            isVisible:true,
            isLoading:false,
search:'',
            show_details:false,
            show_fees:false,

isChanged:false,

modal_view:'',
modal_index:-1,
modal_data:[],

            data_prog_competences:[],
            data_prog_courses:[],

    } }, // END DATA


methods: {


close_modal:function() {
    for (var i = 0; i < this.modal_data.length; i++) {
        this.modal_data[i].isSelected = false    
    }
    document.querySelector('#myModalProgram').classList.remove('is-active');
},


show_modal:function(addWhat, index) {
    this.modal_view = addWhat
    this.modal_index = index

    if (addWhat=='COMP') {this.modal_data=this.data_comp}
    else {this.modal_data=this.data_cour}
    document.querySelector('#myModalProgram').classList.add('is-active');
},

modal_save:function() {
this.isLoading = true;

    if (this.modal_view=='COMP') {
        var query = ''
        for (var i = 0; i < this.modal_data.length; i++) {
            if (+this.modal_data[i].isSelected == true) {
            // CHECK IF ALREADY SAVED .....
                var indx = this.data_prog_competences.findIndex(x => x.comp_ID == this.modal_data[i].id)
                if (indx == -1) {
                    query += `INSERT INTO MyMEQ_RELATION ([prog_ID],[comp_ID]) VALUES (
                    ` + this.data.prog_ID + `,` + this.modal_data[i].id + `) ; `
                }
            } // END IF
            this.modal_data[i].isSelected = false
        } // END FOR

        let formData = new FormData();
        formData.append('query', encodeURIComponent(query));
        axios({
            method: 'post',
            url: this.$url+sessionStorage.getItem('url_query_form'),
            data: {
                query:encodeURIComponent(query)
            },
            
        })
        .then(res => {
            this.isLoading = false;
            this.program_get_competences()
        })

    } else { // END IF COMP

        var query = ''
        var compID = this.data_prog_competences[this.modal_index].comp_ID
// DELETE THE BLANC --
query += ` DELETE FROM MyMEQ_RELATION WHERE prog_ID = ` + this.data.prog_ID + ` AND comp_ID = ` + compID + ` AND cour_ID IS NULL ; ` 


        
        for (var i = 0; i < this.modal_data.length; i++) {
            if (+this.modal_data[i].isSelected == true) {
            // CHECK IF ALREADY SAVED .....
                var indx = this.data_prog_courses.findIndex(x => x.cour_ID == this.modal_data[i].id && x.comp_ID == compID)
        // alert(indx)
                if (indx == -1) {
                    query += `INSERT INTO MyMEQ_RELATION ([prog_ID],[comp_ID],[cour_ID]) VALUES (
                    ` + this.data.prog_ID + `,` + compID  + `,` + this.modal_data[i].id + `) ; `
                }
            }
            this.modal_data[i].isSelected = false
        }

console.log(query)

        let formData = new FormData();
        formData.append('query', encodeURIComponent(query));
        axios({
            method: 'post',
            url: this.$url+sessionStorage.getItem('url_query_form'),
            data: {
                query:encodeURIComponent(query)
            },
            
        })
        .then(res => {
            this.isLoading = false;
            this.program_get_competences()
        })



    } // END IF COUR


document.querySelector('#myModalProgram').classList.remove('is-active');
},
// END MODAL SAVE



program_save:function() {

var titF = ''
if (this.data.prog_TITRE_F != '') {titF = this.data.prog_TITRE_F.replace(/'/g,"''") }
var titE = ''
if (this.data.prog_TITRE_E != '') {titE = this.data.prog_TITRE_E.replace(/'/g,"''") }

if (this.data.prog_ID == 0) {

    var query = `INSERT INTO [MyMEQ_PROGRAM] ([prog_CODE],[prog_YEAR],[prog_CODEPLUS],[prog_TITRE_F],[prog_TITRE_E],[prog_blnAEC],[prog_ACTIVE])
    VALUES ('` + this.data.prog_CODE + `','` + this.data.prog_YEAR + `','` + this.data.prog_CODEPLUS + `','` + titF + `','` + titE + `','` + +this.data.prog_blnAEC + `',` + '1' + `)`

} else {
    var query = `UPDATE [MyMEQ_PROGRAM]
    SET [prog_CODE] = '` + this.data.prog_CODE + `'
    ,[prog_YEAR] = '` + this.data.prog_YEAR + `'
    ,[prog_CODEPLUS] = '` + this.data.prog_CODEPLUS + `'
    ,[prog_TITRE_F] = '` + titF + `'
    ,[prog_TITRE_E] = '` + titE + `'
    ,[prog_blnAEC] = ` + +this.data.prog_blnAEC + `
    ,[prog_ACTIVE] = ` + '1' + `
    WHERE prog_ID = ` + this.data.prog_ID

} // END SAVE IF ----

console.log(query)


          axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
          .then(res => { 
              this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
              this.isChanged = false
          });

},




program_delete_confirm:function() {

// CHECK IF PROGRAM IN USE
    var query = "SELECT TOP(1) student_ID FROM myMEQ_STUDENT WHERE prog_ID = " + this.data.prog_ID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 

        if (!res.data[0]) {

            this.$snotify.html(`<div class="snotifyToast__title"><b>Delete Program?</b></div>
            <div class="snotifyToast__body">`+ this.data.prog_CODE +`</div> ` , {
            timeout: 20000, showProgressBar: true, closeOnClick: false, pauseOnHover: true,position:"centerCenter", type:'error',
                buttons: [
                    {text: 'Ok', action: (toast) => this.program_delete_execute(toast), bold: true},
                    {text: 'Cancel', action: (toast) => {this.$snotify.remove(toast.id); }, bold: true},
                ]
            });

        } else {
            alert('Program in use! To delete this program, please delete all instances in the student dossiers')
        }
    });
},


program_delete_execute:function(toast) {
    this.$snotify.remove(toast.id)

// REMOVE FROM DB
  var query = "DELETE FROM myMEQ_PROGRAM WHERE prog_ID = " + this.data.prog_ID
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
      this.isVisible = false
  });
},

program_get_competences_click:function() {
    this.show_fees = false
    if (this.show_details == true) {this.show_details = false ; return }
    
    this.program_get_competences()

},

program_get_competences:function() {

    

    this.isLoading=true;
    var query = `SELECT MyMEQ_RELATION.rel_ID, MyMEQ_RELATION.prog_ID, MyMEQ_RELATION.comp_ID, MyMEQ_RELATION.cour_ID, MyMEQ_COMPETENCE.comp_CODE, 
    MyMEQ_COMPETENCE.comp_TITRE_F, MyMEQ_COMPETENCE.comp_TITRE_E, MyMEQ_COUR.cour_CODE, MyMEQ_COUR.cour_TITRE_F, 
    MyMEQ_COUR.cour_TITRE_E FROM  MyMEQ_RELATION LEFT OUTER JOIN MyMEQ_COUR ON MyMEQ_RELATION.cour_ID = MyMEQ_COUR.cour_ID LEFT OUTER JOIN MyMEQ_COMPETENCE ON MyMEQ_RELATION.comp_ID = MyMEQ_COMPETENCE.comp_ID
    WHERE (MyMEQ_RELATION.prog_ID = ` + this.data.prog_ID + `)`
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_prog_courses = res.data

        var self = this
        // GET DISTINCT COMPETENCES
        self.data_prog_courses.filter(function(item){
            var i = self.data_prog_competences.findIndex(x => (x.comp_ID == item.comp_ID));
            if(i <= -1){self.data_prog_competences.push(item);}
        })
        this.show_details = true
        this.isLoading=false;

    });
}, 
// END GET COURSES/COmPETENCES

program_get_courses:function(compID) {

    var return_data = []
    for (var i = 0; i < this.data_prog_courses.length; i++) {
        if (this.data_prog_courses[i].comp_ID == compID && this.data_prog_courses[i].cour_ID > 0)
        {return_data.push(this.data_prog_courses[i]); }
    } // END FOR

    return return_data
},
// END GET COURSES

program_fee_show:function() {
    if (this.show_fees == true) {this.show_fees = false ; return }
    this.show_details = false

    this.show_fees = true
},
// END GET FEEs 

// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},
}, // END METHODS



} // END EXPORT
</script>